'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const isHtmlElement = require('./is-html-element.js');

function isEditableElement(el) {
  if (el == null || !isHtmlElement.isHTMLElement(el)) {
    return false;
  }
  try {
    const win = el.ownerDocument.defaultView || window;
    return el instanceof win.HTMLInputElement && el.selectionStart != null || /(textarea|select)/.test(el.localName) || el.isContentEditable;
  } catch {
    return false;
  }
}

exports.isEditableElement = isEditableElement;
